import { useGetDevicesQuery } from 'src/api/device';
import { PageLoader } from 'src/components/PageLoader';
import { PageTitle } from 'src/components/PageTitle';
import { DevicesDataTable } from 'src/features/device/feature-device-list';

import styles from './styles.module.css';

export const Devices = () => {
  const { data: devices, isPending } = useGetDevicesQuery();

  if (isPending) {
    return <PageLoader visible={true} />;
  }

  return (
    <div className={styles.devices}>
      <PageTitle title="My Devices" />
      <DevicesDataTable devices={devices || []} isLoading={isPending} />
    </div>
  );
};
